/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';
// @ts-expect-error TODO: checkout/react-components
import { LoadingSpinner } from '@checkout/react-components';

// Internal modules
import { CI, getContent, useMountLogging, useStartCi } from '@/lib';
import { Button } from '../Button';
import { useConsumerAddBankRedirect } from './hooks';
import { SectionHeader } from '../Headings';
import { CountryDropdown } from '../Locale';
import { Section } from '../Form/StyledComponents';
import { WHITE_COLOR } from '@/styles';
import { ConsumerAddBankFormContainer } from './StyledComponents';

export const ConsumerAddBankForm = (): JSX.Element => {
  CI.endWith(CI.Event.PAY_BANK_RENDER, CI.Status.Ok);
  useStartCi(CI.Event.ADD_BANK_REDIRECT_TO_CONSUMER);
  useMountLogging('ConsumerAddBankForm');
  const [redirectToConsumerAddBank, status] = useConsumerAddBankRedirect();
  return (
    <ConsumerAddBankFormContainer>
      <Section mb={'mb'}>
        <SectionHeader
          header={getContent('sectionHeaders.payWith.guest.base')}
          subheader={getContent('addBank.createAccountWithBank')}
        />
        <CountryDropdown />
        <Button
          testID="continue-button"
          type="button"
          disabled={status.isRedirecting}
          onClick={redirectToConsumerAddBank}
        >
          {getContent('buttons.guest.bank')}
        </Button>
      </Section>

      {status.isRedirecting && (
        <LoadingSpinner
          containToParent={true}
          overlayStyleOverrides={{
            backgroundColor: WHITE_COLOR,
            opacity: 0.9,
          }}
          testId="rc-loading-spinner"
        />
      )}
    </ConsumerAddBankFormContainer>
  );
};
